import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_MOBILE_REQUEST_URL,
  headers:{Authorization: 'Token b12ecb3a1a89016994588aa274dec327ae36789c'}
});
export default api;
